import React from 'react';
import Axios from 'axios';
import { merge } from 'lodash';

import { Journey as JourneyAPI, Result } from '@src/api/types';
import { generateJourney } from '@src/factories';
import useAxiosRequestConfig from '@src/hooks/useAxiosRequestConfig';
import useFlatList from '@src/hooks/useFlatList';
import { Journey } from '@src/types';

type Response = {
  readonly result: Result;
  readonly status: number;
  readonly journeys: JourneyAPI[];
};

const useJourneys = (url: string, params: Array<object> = []) => {
  const axiosRequestConfig = useAxiosRequestConfig();

  const makeRequest = React.useCallback(
    async (offset: number, limit: number): Promise<Journey[]> => {
      const response = await Axios.get<Response>(
        url,
        merge(
          axiosRequestConfig,
          {
            params: { limit, offset },
          }
          // ...params
        )
      );
      return response.data.journeys.map((item) => generateJourney(item));
    },
    [axiosRequestConfig, url]
  );

  return useFlatList(makeRequest);
};

export default useJourneys;
